import { render } from "./ResumeSectionLocationType.vue?vue&type=template&id=c01028f2"
import script from "./ResumeSectionLocationType.vue?vue&type=script&lang=js"
export * from "./ResumeSectionLocationType.vue?vue&type=script&lang=js"

import "./ResumeSectionLocationType.vue?vue&type=style&index=0&id=c01028f2&lang=css"
script.render = render

export default script